import { SvgIcon, SvgIconProps } from '@mui/material';

const TableChartIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path
        d='M19 21H5C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21ZM5 8H19V5H5V8ZM7.5 10H5V19H7.5V10ZM16.5 10V19H19V10H16.5ZM14.5 10H9.5V19H14.5V10Z'
        opacity='0.56'
      />
    </SvgIcon>
  );
};

export default TableChartIcon;
